<script>
const API_URL = process.env.API_SERVER_URL
export default {
  urls: {
    api_ok: API_URL + '/ru-ok/',
    check_all: API_URL + '/auth/',

    login: API_URL + '/auth/login'
  },
  date: {
    date_fmt_month: 'll',
    date_fmt_full: 'lll'
  }
}
</script>



// WEBPACK FOOTER //
// Config.vue?78edd0bb